import { useState, useEffect } from 'react';
import { Link , useNavigate } from 'react-router-dom';
import { ArrowLeft, Mail, LogOut } from 'lucide-react';
import api from '../../utils/api';
import { toast } from 'sonner';


const ContactSubmissions = () => {
  const [submissions, setSubmissions] = useState([]);
  const navigate = useNavigate();

   const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/admin/login');
  };

  useEffect(() => {
    fetchSubmissions();
  }, []);

  const fetchSubmissions = async () => {
    try {
      const response = await api.get('/contact');
      setSubmissions(response.data);
    } catch (error) {
      toast.error('Failed to load submissions');
    }
  };

  const markAsRead = async (id) => {
    try {
      await api.put(`/contact/${id}/read`);
      toast.success('Marked as read');
      fetchSubmissions();
    } catch (error) {
      toast.error('Failed to update');
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="min-h-screen bg-slate-50">
       <nav className="bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <h1 className="text-2xl font-heading font-bold text-gradient">CodeSky Admin</h1>
            <button
              onClick={handleLogout}
              className="flex items-center space-x-2 text-slate-600 hover:text-primary transition-colors"
              data-testid="logout-button"
            >
              <LogOut className="w-5 h-5" />
              <span>Logout</span>
            </button>
          </div>
        </div>
      </nav>
      <nav className="bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center space-x-4">
            <Link to="/admin"><ArrowLeft className="w-5 h-5" /></Link>
            <h1 className="text-2xl font-heading font-bold">Contact Submissions</h1>
          </div>
        </div>
      </nav>

      <div className="max-w-7xl mx-auto px-6 py-8">
        <div className="space-y-4">
          {submissions.length === 0 ? (
            <div className="bg-white rounded-xl p-12 text-center text-slate-600">No submissions yet</div>
          ) : (
            submissions.map((submission) => (
              <div
                key={submission.id}
                className={`bg-white rounded-xl p-6 shadow-sm ${
                  submission.read ? 'opacity-60' : ''
                }`}
                data-testid={`submission-${submission.id}`}
              >
                <div className="flex justify-between items-start mb-4">
                  <div className="flex items-center space-x-3">
                    <Mail className="w-5 h-5 text-primary" />
                    <div>
                      <h3 className="font-bold text-lg">{submission.name}</h3>
                      <p className="text-sm text-slate-600">{submission.email}</p>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="text-sm text-slate-600">{formatDate(submission.created_at)}</p>
                    {!submission.read && (
                      <button
                        onClick={() => markAsRead(submission.id)}
                        className="text-xs text-primary hover:underline mt-1"
                      >
                        Mark as read
                      </button>
                    )}
                  </div>
                </div>
                <div className="border-t border-slate-100 pt-4">
                  <p className="font-medium text-slate-900 mb-2">Subject: {submission.subject}</p>
                  <p className="text-slate-700">{submission.message}</p>
                  {submission.phone && (
                    <p className="text-sm text-slate-600 mt-2">Phone: {submission.phone}</p>
                  )}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactSubmissions;
